import { Fragment } from "react/jsx-runtime";

import MaterialChip from "#modules/quoteRequestLines/view/MaterialChip";
import { getSurfaceTreatment } from "#modules/similarPart/domain/getSurfaceTreatment";
import { QuoteRequestLinesSimilarPartDto } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";
import { Icon } from "#shared/icons/Icon";
import { DimensionChip } from "#shared/view/components/DimensionChip";
import { SurfaceTreatmentChip } from "#shared/view/components/SurfaceTreatmentChip";
import { Chip } from "#shared/view/designSystem/Chip";
import { MaterialGradeSchema } from "shared";

export const ClusterCardChips = ({
  quoteRequestLine,
}: {
  quoteRequestLine: QuoteRequestLinesSimilarPartDto;
  dimensionsUpdatable?: boolean;
}) => {
  const isSamePart = (quoteRequestLine.cosineSimilarity || 0) === 1;
  const surfaceTreatment = getSurfaceTreatment([quoteRequestLine]);

  return (
    <Fragment>
      {isSamePart && (
        <Chip size="xs" icon={<Icon name="star" size={12} />} checked color="green.4" autoContrast>
          {`pièce identique`}
        </Chip>
      )}
      <DimensionChip part={quoteRequestLine.part} quoteRequestLine={quoteRequestLine} maw="100%" />

      <MaterialChip
        materialGrade={quoteRequestLine.materialGrade ?? MaterialGradeSchema.enum.OTHER}
        maw="100%"
      />
      {surfaceTreatment && <SurfaceTreatmentChip surfaceTreatment={surfaceTreatment} maw="100%" />}
    </Fragment>
  );
};
